import { SerializableObject } from './serializable-object';

export class VerificationStatus extends SerializableObject {
  public verified: boolean;
}
